module.exports = "/static-assets/_next/static/images/img-d223c16f10-5d9cf3b749d81af37caba558de5523ad.webp";